import { Slider, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

import type { FC } from "react";

interface Props {
  zoom: number;
  setZoom: (value: number) => void;
}

export const ZoomControl: FC<Props> = ({ zoom, setZoom }) => {
  const { t } = useTranslation();

  return (
    <Stack gap="xs">
      <Text size="sm">{t("components.userAvatar.zoom")}</Text>
      <Slider
        value={zoom}
        onChange={setZoom}
        min={1}
        max={3}
        step={0.1}
        label={(value) => `${Math.round(value * 100)}%`}
      />
    </Stack>
  );
};
